(() => {
  if (customElements.get('oeo-offer-player')) return;
  class OeoOfferPlayer extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        const video = this.querySelector('video');
        const button = this.querySelector('[data-oeo-video-toggle]');
        if (!video || !button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const sync = () => {
          button.textContent = video.paused ? 'Play video' : 'Pause video';
          button.setAttribute('aria-label', video.paused ? 'Play unboxing video' : 'Pause unboxing video');
        };
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (reduced.matches) {
          video.autoplay = false;
          video.pause();
        }
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(sync);
          else video.pause();
        }, options);
        video.addEventListener('play', sync, options);
        video.addEventListener('pause', sync, options);
        video.addEventListener('ended', sync, options);
        sync();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('oeo-offer-player', OeoOfferPlayer);
})();
